// frontend/src/components/CreatePost/TermsCheckbox.jsx
import { useState } from "react";
import {  AlertCircle } from "lucide-react";

export default function TermsCheckbox({ onAcceptChange, errors }) {
  const [acceptOwnership, setAcceptOwnership] = useState(false);
  const [acceptTruthfulness, setAcceptTruthfulness] = useState(false);

  const handleOwnershipChange = (checked) => {
    setAcceptOwnership(checked);
    onAcceptChange({ ownership: checked, truthfulness: acceptTruthfulness });
  };

  const handleTruthfulnessChange = (checked) => {
    setAcceptTruthfulness(checked);
    onAcceptChange({ ownership: acceptOwnership, truthfulness: checked });
  };

  const hasError = errors?.terms && !acceptOwnership && !acceptTruthfulness;

  return (
    <div className="space-y-4 p-4 bg-gray-50 rounded-xl border border-gray-200">
      <div className="flex items-start gap-3">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            id="ownership"
            checked={acceptOwnership}
            onChange={(e) => handleOwnershipChange(e.target.checked)}
            className="w-4 h-4 text-[#449779] rounded border-gray-300 focus:ring-[#449779]"
          />
        </div>
        <label htmlFor="ownership" className="text-sm text-gray-700 leading-relaxed cursor-pointer">
          Declaro ser proprietário legítimo do item anunciado ou possuir autorização para sua venda ou doação.
          <span className="text-red-500 ml-1">*</span>
        </label>
      </div>

      <div className="flex items-start gap-3">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            id="truthfulness"
            checked={acceptTruthfulness}
            onChange={(e) => handleTruthfulnessChange(e.target.checked)}
            className="w-4 h-4 text-[#449779] rounded border-gray-300 focus:ring-[#449779]"
          />
        </div>
        <label htmlFor="truthfulness" className="text-sm text-gray-700 leading-relaxed cursor-pointer">
          Confirmo que as informações e imagens deste anúncio são verdadeiras.
          <span className="text-red-500 ml-1">*</span>
        </label>
      </div>

      {hasError && (
        <p className="text-xs text-red-500 flex items-center gap-1 mt-2">
          <AlertCircle className="w-3 h-3" />
          Você precisa aceitar os termos para publicar o anúncio.
        </p>
      )}
    </div>
  );
}